/*
  Ported from src/components/Descramble.tsx — matrix-decrypt hover effect.
  Custom element usage:
    <oblivion-descramble>INITIER LE SYSTÈME</oblivion-descramble>
  For text that must keep an explicit line break at a fixed position (e.g.
  the footer's "NO / COMPROMISE." heading), pass lines as a JSON array
  attribute instead of relying on markup line breaks, since the browser
  auto-wrap point would otherwise jump every frame as scrambled glyphs
  change width:
    <oblivion-descramble data-lines='["NO","COMPROMISE."]'></oblivion-descramble>
  Only letters/digits are used as scramble glyphs — punctuation like — or /
  renders much wider than most glyphs in the brutalist display font and can
  push the line past its container width mid-scramble.
*/
(function () {
  var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  class OblivionDescramble extends HTMLElement {
    connectedCallback() {
      var linesAttr = this.getAttribute('data-lines');
      if (linesAttr) {
        try {
          this.text = JSON.parse(linesAttr).join('\n');
        } catch (e) {
          this.text = this.textContent;
        }
      } else {
        this.text = this.textContent;
      }

      if (this.text.indexOf('\n') !== -1) {
        this.style.whiteSpace = 'pre-line';
      }

      this.textContent = this.text;
      this._frame = null;

      this._onEnter = this.scramble.bind(this);
      this._onLeave = this.reset.bind(this);
      this.addEventListener('mouseenter', this._onEnter);
      this.addEventListener('mouseleave', this._onLeave);
    }

    disconnectedCallback() {
      if (this._frame) cancelAnimationFrame(this._frame);
      this.removeEventListener('mouseenter', this._onEnter);
      this.removeEventListener('mouseleave', this._onLeave);
    }

    scramble() {
      var el = this;
      var text = this.text;
      if (this._frame) cancelAnimationFrame(this._frame);

      var iteration = 0;
      var total = text.length;

      function tick() {
        el.textContent = text
          .split('')
          .map(function (char, i) {
            if (char === ' ' || char === '\n') return char;
            if (i < iteration) return text[i];
            return CHARS[Math.floor(Math.random() * CHARS.length)];
          })
          .join('');

        if (iteration >= total) {
          el.textContent = text;
          return;
        }
        iteration += 1 / 2.2;
        el._frame = requestAnimationFrame(tick);
      }
      tick();
    }

    reset() {
      if (this._frame) cancelAnimationFrame(this._frame);
      this.textContent = this.text;
    }
  }

  if (!customElements.get('oblivion-descramble')) {
    customElements.define('oblivion-descramble', OblivionDescramble);
  }
})();
